// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".c54a6639a8a985ba41dcc08314b866a22d954311.chunk.bundle.js";
};